export const DATE_FIELD = 'schedule.schedule.date';
export const DAYS_OF_WEEK_FIELD = 'schedule.schedule.daysOfTheWeek';
export const LOCATION_FIELD = 'schedule.schedule.location';
export const NODE_ID_FIELD = 'nodeId';
export const TIME_RANGES_FOR_DATE_FIELD = 'schedule.schedule.timeRanges';
export const TIME_RANGES_FOR_WEEKDAY_FIELD = 'schedule.schedule.TimeRanges';
export const TYPE_FIELD = 'schedule.type';
